const translateDetail = (detail, trObj) => {
  if (!detail) return '';

  if (typeof trObj === 'function') {
    return trObj(detail) || '';
  }

  return detail.long_description_eng || detail.long_description_deu || '';
};

export const getAutomobileSummary = (automobile, trObj, formatDate) => {
  if (!automobile) return '';

  const formattedDate =
    automobile.initial_reg_date && typeof formatDate === 'function'
      ? formatDate(automobile.initial_reg_date)
      : automobile.initial_reg_date;

  return [
    translateDetail(automobile.auto_brand_detail, trObj),
    automobile.model_series,
    translateDetail(automobile.color_detail, trObj),
    formattedDate,
  ]
    .filter(Boolean)
    .join(' - ');
};
